import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios';
import { Hexabase } from 'hexabase-sdk';
import { newMedicalItem, RegisterMedicalResponse, t_medical_institution, UpdateMedicalResponse } from 'types';

class MedicalService {
  private readonly axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  getMedicals(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_medical_institution/items/search`,
      data: param,
    };
    return this.axios(request);
  }

  getDataStoreFieldMedicals(params: { appId: string; dataStoreId: string }): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'GET',
      url: `applications/CPAP/datastores/${params.dataStoreId}/fields`,
    };
    return this.axios(request);
  }

  medicalItem(data: newMedicalItem): AxiosPromise<RegisterMedicalResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/t_medical_institution/items/new`,
      data: {
        item: data.item,
        return_item_result: true,
      },
    };
    return this.axios(request);
  }

  updateMedical(param: t_medical_institution): AxiosPromise<UpdateMedicalResponse> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/${param.d_id}/items/edit/${param.i_id}`,
      data: { item: param, use_display_id: true, is_force_update: true, return_item_result: true },
    };
    return this.axios(request);
  }

  async getCountFacilityCode(payment_method: string): Promise<any> {
    try {
      let countCode = await Hexabase.items().getItemsAsync({
        project_id: 'CPAP',
        datastore_id: 't_facility_code_count',
        per_page: 1,
        page: 1,
        use_display_id: true,
        conditions: [
          {
            search_value: [payment_method],
            data_type: 'text',
            id: 'payment_method',
            exact_match: false,
            include_null: false,
          },
        ],
      });
      return countCode.items;
    } catch (e) {
      return null;
    }
  }
  updateCountFacilityCode(param: any): AxiosPromise<any> {
    const request: AxiosRequestConfig = {
      method: 'POST',
      url: `applications/CPAP/datastores/${param.d_id}/items/edit/${param.i_id}`,
      data: { item: { count: param.count }, use_display_id: true, is_force_update: true, return_item_result: true },
    };
    return this.axios(request);
  }
}

export default MedicalService;
